<div class="modal fade" id="{{ modalId() }}" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable {{ size() }}">
    <div class="modal-content">
      <div class="modal-header d-flex align-items-center">
        <mat-icon style="transform: scale(0.9);">info</mat-icon>
        <h1 class="modal-title fs-5" id="staticBackdropLabel">
          {{ modalTitle() }}
        </h1>
        <button type="button" class="btn-close" 
          data-bs-dismiss="modal" aria-label="Close"
          (click)="onCancel()">
        </button>
      </div>
      <div class="modal-body" [innerHTML]="modalBodyMessage()" #modalBody>
        <!-- {{modalBodyMessage()}} -->
      </div>
    </div>
  </div>
</div>